export enum MessageType {
  Image = "i",
  Text = "t",
  SystemSuccess = "system_success",
  SystemWarning = "system_warning",
  SystemError = "system_error",
  UserInfo = "user_info",
}

export const PDF_MIME_TYPE = "application/pdf";
export const IMAGE_MIME_TYPES = ["image/jpeg", "image/png"];
export const ATTACHMENT_ACCEPT = [PDF_MIME_TYPE, ...IMAGE_MIME_TYPES].join(", ");

export enum ChatTab {
  New = "n",
  My = "m",
  Colleagues = "c",
  Archive = "a",
}
